module.exports = __webpack_public_path__ + "static/media/tree_summary.379ad412.svg";